import { User } from '.';

export interface AwardJudge {
  awardJudgeId: number;
  awardId: number;
  emailAddress: string;
  user?: User;
  judgingStarted: boolean;
  hasJudged: boolean;
}

export function blankAwardJudge(): AwardJudge {
  return {
    awardJudgeId: 0,
    awardId: 0,
    emailAddress: '',
    judgingStarted: false,
    hasJudged: false,
  };
}
